import React, { useEffect, useState } from "react";
import MultiSelectBoxItem from "./MultiSelectBoxItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";

export default function MultiSelectBox({
  label = "",
  hint = "",
  options = [],
  option_name = "name",
  option_value = "value",
  onChange,
  selectedValues = [],
  applyButton = false,
  applyFilterText = "Anwenden",
  optIdPrefix = null,
  error,
}) {
  const selected = options.filter((option) =>
    selectedValues.includes(option[option_value])
  );

  const [showMenu, setShowMenu] = useState(false);
  const idPrefix = optIdPrefix ?? label.replace(" ", "");

  const { t } = useTranslation("dashboard");

  const SelectAll = () => {
    onChange(options.map((option) => option[option_value]));
  };

  function UnSelectAll() {
    onChange([]);
  }

  function clickAway(e) {
    if (
      document
        .getElementById(idPrefix + "multiSelectBox")
        ?.contains(e.target) ||
      document
        .getElementById(idPrefix + "multiSelectButton")
        ?.contains(e.target)
    ) {
      return;
    }
    setShowMenu(false);
  }

  function onSelect(value) {
    if (value === "all") {
      if (selected.length !== options.length) {
        SelectAll();
      } else {
        UnSelectAll();
      }
    } else if (!selected.find((option) => option[option_value] === value)) {
      const option = options.find((option) => option[option_value] === value);
      onChange([
        ...selected.map((option) => option[option_value]),
        option[option_value],
      ]);
    } else {
      onChange(
        selected
          .filter((options) => options[option_value] !== value)
          .map((option) => option[option_value])
      );
    }
  }

  useEffect(() => {
    window.addEventListener("click", clickAway);
    return () => {
      window.removeEventListener("click", clickAway);
    };
  }, []);

  const displayText = () => {
    if (options.length === selected.length) {
      return "Alle";
    } else if (selected.length === 0) {
      return "Keine";
    }

    return selected.map((option) => option[option_name]).join(", ");
  };

  return (
    <Form.Group className="dropdown d-flex flex-column">
      <Form.Label className="text-truncate">{label}</Form.Label>
      <button
        id={idPrefix + "multiSelectButton"}
        style={{ minWidth: "100%", width: "100%", height: "40px" }}
        className="btn btn-white border border-secondary btn-block text-truncate mr-2 text-left"
        type="button"
        onClick={() => setShowMenu(!showMenu)}
      >
        <span className={"ml-2"}>{displayText()}</span>
        {!showMenu && (
          <FontAwesomeIcon
            style={{ float: "right" }}
            className="mt-1 mr-1"
            icon={faCaretDown}
            onClick={(e) => {
              e.stopPropagation();
              setShowMenu(!showMenu);
            }}
          />
        )}
        {showMenu && (
          <FontAwesomeIcon
            style={{ float: "right" }}
            className="mt-1 mr-1"
            icon={faCaretUp}
            onClick={(e) => {
              e.stopPropagation();
              setShowMenu(!showMenu);
            }}
          />
        )}
      </button>

      {showMenu && (
        <div
          style={{ width: "" }}
          className="dropdown-menu d-block w-100 p-3 justify-content-left align-items-left"
          id={idPrefix + "multiSelectBox"}
        >
          {options.length > 1 && (
            <div
              className="border-bottom ui-border-color-c-gray"
              onClick={() => onSelect("all")}
            >
              <MultiSelectBoxItem
                label="Alle"
                value="all"
                selected={selected.length === options.length}
                onClick={() => onSelect("all")}
              />
            </div>
          )}
          {options.map((option) => (
            <MultiSelectBoxItem
              key={option[option_value]}
              selected={
                !!selected.find((o) => o[option_value] === option[option_value])
              }
              onSelect={() => onSelect(option[option_value])}
              label={option[option_name]}
              value={option[option_value]}
              color={option?.color ?? "transparent"}
            />
          ))}
          {applyButton && (
            <div className="w-100 d-flex p-1 px-2 justify-content-end">
              <button
                className="btn btn-sm btn-primary rounded-lg d-flex justify-content-center align-items-center"
                type="button"
                onClick={() => {
                  notify();
                  setShowMenu(!showMenu);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon-tabler icons-tabler-outline icon-tabler-filter-check mr-1"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M11.18 20.274l-2.18 .726v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3" />
                  <path d="M15 19l2 2l4 -4" />
                </svg>
                {applyFilterText}
              </button>
            </div>
          )}
        </div>
      )}
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      {error && (
        <div>
          <small className="text-danger">{error}</small>
        </div>
      )}
    </Form.Group>
  );
}
